import ActionTypes from "../../../../constants/ActionTypes";
import { ISendOrderToEmailAction, ISetSendOrderToEmailStatusAction } from "./types";

export const sendOrderToEmail = (data: any): ISendOrderToEmailAction => ({
  type: ActionTypes.ORDER.MANHATTAN.SEND_ORDER_TO_EMAIL,
  payload: data,
});

export const setSendOrderToEmailStatus = (status: boolean): ISetSendOrderToEmailStatusAction => ({
  type: ActionTypes.ORDER.MANHATTAN.SET_SEND_ORDER_TO_EMAIL_STATUS,
  payload: status
});
